document.addEventListener("DOMContentLoaded", function () {
  let updatedPrices = {}; // 🔥 Almacena los precios actualizados

  function waitForElement(selector, callback) {
    const observer = new MutationObserver((mutations, obs) => {
      const element = document.querySelector(selector);
      if (element) {
        obs.disconnect();
        callback(element);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  waitForElement(".sls-purchase-options-container", function (targetElement) {
    console.log("Elemento encontrado:", targetElement);

    const observer = new MutationObserver(() => {
      observer.disconnect();
      updatePrices();
      observer.observe(targetElement, { childList: true, attributes: true, subtree: true });
    });

    function updatePrices() {
      const optionElement = targetElement.querySelector('option[value="689639031109"]');
      if (!optionElement) return;

      const parentContainer = optionElement.closest(".sls-option-container");
      if (!parentContainer) return;

      const originalPriceElement = parentContainer.querySelector(".sls-original-price");
      const discountPriceElement = parentContainer.querySelector(".sls-price");

      if (originalPriceElement && discountPriceElement) {
        let originalPrice = parseFloat(originalPriceElement.innerText.replace("EUR", "").trim());
        let discountPrice = parseFloat(discountPriceElement.innerText.replace("EUR", "").trim());
        console.log("precio original sin formatear:", originalPriceElement);
        console.log("precio original:", originalPrice);
        if (!originalPriceElement.dataset.original) {
          originalPriceElement.dataset.original = originalPrice;
          discountPriceElement.dataset.original = discountPrice;
        } else {
          originalPrice = parseFloat(originalPriceElement.dataset.original);
          discountPrice = parseFloat(discountPriceElement.dataset.original);
        }

        // 🔥 Guardamos los nuevos precios en la variable global
        updatedPrices.original = originalPrice * 3;
        updatedPrices.discount = discountPrice * 3;

        // 🔄 Aplicamos los precios actualizados en la interfaz
        originalPriceElement.innerText = `${updatedPrices.original.toFixed(2)} €`;
        discountPriceElement.innerText = `${updatedPrices.discount.toFixed(2)} €`;

        console.log("Nuevo precio aplicado:", updatedPrices);
      }
    }

    updatePrices();
    observer.observe(targetElement, { childList: true, attributes: true, subtree: true });
  });

  function observePurchaseOptions() {
    const purchaseOptionsContainer = document.querySelector(".sls-purchase-options-container");

    if (!purchaseOptionsContainer) {
      setTimeout(observePurchaseOptions, 500);
      return;
    }

    const observer = new MutationObserver(() => {
      const activeOption = purchaseOptionsContainer.querySelector(".sls-option-container.sls-active");
      const quantityDiv = document.querySelector(".product-form__quantity");
      const quantityInput = document.querySelector('input[name="quantity"]');
      const shopifyPriceElement = document.querySelector(".price-item.price-item--regular");
      const moneyElement = shopifyPriceElement?.querySelector(".money");

      if (!activeOption || !quantityDiv || !quantityInput || !shopifyPriceElement || !moneyElement) return;

      const selectedOption = activeOption.querySelector('option[value="689639031109"]');

      // 🔥 Usamos el precio actualizado en lugar del original de Shopify
      const newShopifyPrice = updatedPrices.discount || parseFloat(shopifyPriceElement.innerText.replace("EUR", "").trim()) * 3;

      let customPriceElement = document.querySelector("#custom-price");
      if (!customPriceElement) {
        customPriceElement = document.createElement("span");
        customPriceElement.id = "custom-price";
        customPriceElement.style.display = "none";
        shopifyPriceElement.parentElement.appendChild(customPriceElement);
      }

      if (selectedOption) {
        console.log("Option 689639031109 seleccionada, actualizando...");

        quantityDiv.style.display = "block";
        if (quantityInput.value != 3) {
          quantityInput.value = 3;
          quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
        }

        shopifyPriceElement.style.display = "none";
        customPriceElement.innerText = `${newShopifyPrice.toFixed(2)} €`;
        customPriceElement.style.display = "inline";
      } else {
        console.log("Otra opción seleccionada, restaurando...");

        if (quantityInput.value != 1) {
          quantityInput.value = 1;
          quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
        }

        shopifyPriceElement.style.display = "inline";
        customPriceElement.style.display = "none";
      }

      const hasRoleButton = activeOption.getAttribute("role") === "button";
quantityDiv.style.display = hasRoleButton ? "block" : "none";

      
    });

    observer.observe(purchaseOptionsContainer, { childList: true, subtree: true, attributes: true });
  }

  observePurchaseOptions();
});
